import React from 'react';
import { compose, withHandlers } from 'recompose';
import { Table } from 'reactstrap';
import { NotificationManager } from 'react-notifications';
import {
  TableContainer,
  Pagination,
  TableDataFetch,
  AddNewButton,
  withTable,
  TableSearch,
  BulkDeleteButton,
  EditDeleteButtons,
  ViewingRecords,
} from 'components/common/Tables/index';
import Page from '../../components/common/Page';

export const UserList = ({
  selected,
  match,
  url = 'users',
  deleteUrl = '',
  setSelected,
  ordering,
  setOrdering,
  data,
  setData,
  limit,
  offset,
  setOffset,
  search,
  setSearch,
  isDeleteModalOpen,
  toggleDeleteModal,
  onDeleteItem,
  onDeleted,
  refreshToken,
  readOnly,
}) => (
  <Page title="Users">
    <TableSearch onChange={setSearch} value={search} />
    <BulkDeleteButton
      className="float-right mb-2"
      toggleModal={toggleDeleteModal}
      selected={selected}
      url={url}
      deleteUrl={deleteUrl}
      onDeleted={onDeleted}
      isModalOpen={isDeleteModalOpen}
      readOnly={readOnly}
    />
    <AddNewButton
      resource="User"
      match={match}
      className="float-left mb-2"
      readOnly={readOnly}
    />
    <TableContainer
      items={data.results}
      ordering={ordering}
      onOrderingChanged={setOrdering}
      selected={selected}
      onSelectedChanged={setSelected}
    >
      <Table>
        <thead>
          <tr>
            <th select width="5%" />
            <th sortBy="username">Username</th>
            <th sortBy="first_name">First Name</th>
            <th sortBy="last_name">Last Name</th>
            <th sortBy="email">Email</th>
            <th sortBy="role_name">Role</th>
            <th sortBy="is_active">Active</th>
            <th />
          </tr>
        </thead>
        <tbody>
          {data.results.map(i => (
            <tr key={i.id}>
              <td select />
              <td>{i.username}</td>
              <td>{i.first_name}</td>
              <td>{i.last_name}</td>
              <td>{i.email}</td>
              <td>{i.role_name}</td>
              <td>
                {i.is_active ? (
                  <span className="fa fa-check-circle text-success" />
                ) : (
                  <span className="fa fa-times-circle text-danger" />
                )}
              </td>
              <td className="text-right">
                <EditDeleteButtons
                  url={match.url}
                  id={i.id}
                  onDelete={onDeleteItem}
                  readOnly={readOnly}
                />
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </TableContainer>
    <TableDataFetch
      ordering={ordering}
      refreshToken={refreshToken}
      search={search}
      limit={limit}
      url={url}
      offset={offset}
      onDataFetched={setData}
    />
    <ViewingRecords
      offset={offset}
      limit={limit}
      count={data.count}
      className="float-left"
    />
    <div className="float-right">
      <Pagination
        size="sm"
        count={data.count}
        limit={limit}
        offset={offset}
        onOffsetChanged={setOffset}
      />
    </div>
  </Page>
);

const enhance = compose(
  withTable({ limit: 100 }),
  withHandlers({
    onDeleted: ({ onDeleted, selected }) => props => {
      onDeleted(props);
      if (props === null) {
        // === null => success
        const resource =
          selected && Object.keys(selected).length > 1 ? 'Users' : 'User';
        NotificationManager.success(`${resource} deleted successfully.`);
      }
    },
  })
);

export default enhance(UserList);



// WEBPACK FOOTER //
// ./src/pages/Users/List.jsx